import { render } from "./Familys.vue?vue&type=template&id=18175ec5"
import script from "./Familys.vue?vue&type=script&lang=js"
export * from "./Familys.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__